import React from "react";
import { NavLink } from "react-router-dom";
import logo from './logo.png';


function Navigation() {
  return (
    <div className="navigation">
      <nav className="navigation navbar-expand navbar-light fixed-top">
      <div className="container">
          <NavLink to="/" className="navbar-brand">
            <img src={logo} alt="Logo" style={{ width: "40px", height: "auto" }} />
          </NavLink>
        </div>
      </nav>
    </div>
  );
}

export default Navigation;
